var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',_vm._b({class:['app-image', { 'app-image_id': _vm.imgId }, { 'app-image_contain': _vm.contain }],attrs:{"alt":_vm.alt,"height":_vm.height,"loading":_vm.lazy ? 'lazy' : 'eager',"width":_vm.width}},'img',_setup.srcAttrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }